import { useTheme } from '@mui/material';
import React, { SVGProps } from 'react';

interface Props extends SVGProps<SVGSVGElement> {
  color?: React.CSSProperties['color'];
}

const GraphLiveWindIcon: React.FC<Props> = ({ width = 22, height = 14, color, ...props }) => {
  const theme = useTheme();
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 22 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0 8h2v4a1 1 0 1 1-2 0V8ZM4 8h2v5a1 1 0 1 1-2 0V8ZM12 4a1 1 0 1 1 2 0v4h-2V4ZM16 3a1 1 0 1 1 2 0v5h-2V3ZM20 1a1 1 0 1 1 2 0v7h-2V1ZM8 8h2v3a1 1 0 1 1-2 0V8Z"
        fill={color || theme.palette.secondary.main}
      />
    </svg>
  );
};

export default GraphLiveWindIcon;
